"use client"

import Logo from "./Logo"
import "./NotFound.css"

const NotFound = () => {
  return (
    <div className="notfound-wrapper">
      <div className="notfound-gradient-orb notfound-orb-1"></div>
      <div className="notfound-gradient-orb notfound-orb-2"></div>

      <div className="notfound-content">
        {/*<div className="notfound-error-code">
          <Logo width={100} height={50} />
        </div>*/}

        <div className="notfound-message">
          <h1 className="notfound-title">Page Not Found</h1>
          <p className="notfound-description">
            We couldn't find the page you're looking for. It might have been removed, renamed, or it never existed.
          </p>
        </div>

        <div className="notfound-actions">
          <button className="notfound-btn notfound-btn-primary" onClick={() => (window.location.href = "/")}>
            <svg className="notfound-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path
                d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline points="9 22 9 12 15 12 15 22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Back to Home
          </button>
          <button className="notfound-btn notfound-btn-secondary" onClick={() => window.history.back()}>
            <svg className="notfound-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="19" y1="12" x2="5" y2="12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <polyline points="12 19 5 12 12 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Previous Page
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
